export default "__VITE_ASSET__CX_gEK2X__"